import React, { Component } from "react";

class CotisantFilters extends Component {
  render() {
    const { activeTab, onTabChange, selectedFrequency, onFrequencyChange, period } = this.props;
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <div style={{ display: "flex", gap: 20 }}>
          <span 
            style={{
              cursor: "pointer",
              fontWeight: activeTab === "cotisation" ? "bold" : "normal",
              borderBottom: activeTab === "cotisation" ? "3px solid #29394D" : "3px solid #ccc",
              color: activeTab === "cotisation" ? "#29394D" : "#555",
              paddingBottom: 5,
              width: 165,
              textAlign: "center",
            }}
            onClick={() => onTabChange("cotisation")}
          >
            Cotisation
          </span>
          <span 
            style={{
              cursor: "pointer",
              fontWeight: activeTab === "chiffreAffaire" ? "bold" : "normal",
              borderBottom: activeTab === "chiffreAffaire" ? "3px solid #29394D" : "3px solid #ccc",
              color: activeTab === "chiffreAffaire" ? "#29394D" : "#555",
              paddingBottom: 5,
              width: 165,
              textAlign: "center",
            }}
            onClick={() => onTabChange("chiffreAffaire")}
          >
            Chiffre d’affaire
          </span>
        </div>

        {
          period.length === 1 && 
          <div style={{ display: "flex", background: "#F0F0F0", borderRadius: 20, padding: 4 }}>
              {["MONTHLY", "YEARLY"].map((period) => (
                  <button
                  key={period}
                  onClick={() => onFrequencyChange(period)}
                  style={{
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: 20,
                      cursor: "pointer",
                      background: selectedFrequency === period ? "#6D7F92" : "transparent",
                      color: selectedFrequency === period ? "white" : "#555",
                      fontWeight: selectedFrequency === period ? "bold" : "normal",
                      width: "120px",
                      height: "32px",
                  }}
                  >
                  {period}
                  </button>
              ))}
          </div>
        }
      </div>
    );
  }
}

export default CotisantFilters;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CotisantFilters.js